/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LatestPostsToApproveDto } from '../../models/latest-posts-to-approve-dto';

export interface GetLatestPostsToApprove$Params {
}

export function getLatestPostsToApprove(http: HttpClient, rootUrl: string, params?: GetLatestPostsToApprove$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LatestPostsToApproveDto>>> {
  const rb = new RequestBuilder(rootUrl, getLatestPostsToApprove.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LatestPostsToApproveDto>>;
    })
  );
}

getLatestPostsToApprove.PATH = '/api/editorial/latest-posts-to-approve';
